import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';

class LoanScheduleNoteDialog extends React.Component {
  state = {
    open: false,
    note: this.props.note || ''
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = () => {
    this.props.save(this.state.note);
    this.setState({ open: false });
  }

  transition = (props) => {
    return <Slide direction="up" {...props} />;
  }

  render() {
    return (
      <div className={this.props.className}>
        <Button variant={this.props.variant} disabled={this.props.disabled} color={this.props.color} onClick={this.handleClickOpen}><CreateIcon style={{ fontSize: 20 }}/>{this.props.buttonLabel}</Button>
        <Dialog
          fullWidth={true}
          open={this.state.open}
          TransitionComponent={this.transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.title}
          </DialogTitle>
          <DialogContent>
            <TextField
              fullWidth={true}
              autoFocus
              margin="dense"
              value={this.state.note}
              onChange={(e) => {this.setState({note: e.target.value})}}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleConfirm} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default LoanScheduleNoteDialog;



// WEBPACK FOOTER //
// ./src/components/Loans/LoanScheduleNoteDialog.js